import { ObjectType, Field, InputType, Int, ID } from 'type-graphql'
import { DataSummary } from './data-summary.js'

@InputType()
export class NewDataSummary {
  @Field({ description: 'Name of the data summary for identification.' })
  name: string

  @Field({ nullable: true })
  description?: string
}

@InputType()
export class DataSummaryPatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true, description: 'Description of the data summary.' })
  description?: string

  @Field({ nullable: true, description: 'Create/Update flag for batch operations.' })
  cuFlag?: string
}

@ObjectType({
  description: 'Represents a dynamic data summary with flexible key-value pairs for different summary periods.'
})
export class DynamicDataSummary {
  @Field({ nullable: true, description: 'Month identifier for the summary period.' })
  month?: string = ''

  @Field({ nullable: true, description: 'Date identifier for the summary period.' })
  date?: string = ''

  @Field({ nullable: true, description: 'Period identifier for the summary (e.g., hour, day, shift).' })
  period?: string = ''

  @Field({ nullable: true, description: 'Total number of data samples in this summary period.' })
  count?: number

  @Field({ nullable: true, description: 'Number of out-of-control (OOC) samples in this summary period.' })
  countOoc?: number

  @Field({ nullable: true, description: 'Number of out-of-specification (OOS) samples in this summary period.' })
  countOos?: number

  @Field({ nullable: true, description: 'First partition key for data categorization.' })
  key01?: string = ''

  @Field({ nullable: true, description: 'Second partition key for data categorization.' })
  key02?: string = ''

  @Field({ nullable: true, description: 'Third partition key for data categorization.' })
  key03?: string = ''

  @Field({ nullable: true, description: 'Fourth partition key for data categorization.' })
  key04?: string = ''

  @Field({ nullable: true, description: 'Fifth partition key for data categorization.' })
  key05?: string = ''

  @Field({ nullable: true, description: 'First aggregated data value for this summary period.' })
  data01?: number

  @Field({ nullable: true, description: 'Second aggregated data value for this summary period.' })
  data02?: number

  @Field({ nullable: true, description: 'Third aggregated data value for this summary period.' })
  data03?: number

  @Field({ nullable: true, description: 'Fourth aggregated data value for this summary period.' })
  data04?: number

  @Field({ nullable: true, description: 'Fifth aggregated data value for this summary period.' })
  data05?: number
}

@ObjectType({ description: 'Represents a paginated list of data summaries.' })
export class DataSummaryList {
  @Field(type => [DataSummary], { description: 'List of data summaries.' })
  items: DataSummary[]

  @Field(type => Int, { description: 'Total number of data summaries in the list.' })
  total: number
}
